import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, formDataCommonFunctionPutWithoutAuth, serviceCall } from '../../serviceCall'

const acceptCompanyInvitationApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunctionPut(data,apiConstants.COMPANIES.ACCEPT_COMPANY_INVITATION)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default acceptCompanyInvitationApi;